import { Component, OnInit } from '@angular/core';
import { CLASS_INPUT } from 'src/app/shared/constants';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import * as fromAuth from './../../../store';
import { User } from 'src/app/users/models/user';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalChangePasswordComponent } from '../../components/modal-change-password/modal-change-password.component';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.scss']
})
export class ViewProfileComponent implements OnInit {

  classInput: string = CLASS_INPUT[0];
  isReadOnly = true;
  user: User;
  roles: string;
  rolesTraduction: any;
  formGroupProfile: FormGroup;


  constructor(
    private fb: FormBuilder,
    private storeAuth: Store<fromAuth.AuthState>,
    private location: Location,
    private modalService: NgbModal,
    private translate: TranslateService
  ) {
      this.translate.get('rolesModal.roles')
      .subscribe((res) => this.rolesTraduction = res);
    }

  ngOnInit() {

    this.storeAuth.pipe(
      select(fromAuth.selectSessionUser)
    ).subscribe(user => {
      this.user = user;
      this.roles = this.user.roles.map(e => this.rolesTraduction[e.code].shortName).join('<br>');
      this.setValuesFormBuilder();
    });
  }

  setValuesFormBuilder() {
    this.formGroupProfile = this.fb.group({
      name: this.user.name,
      lastName: this.user.lastName,
      entity: this.user.entity,
      email: this.user.email,
    });
  }

  onClickCambiarContrasenaModal() {
    const modalRef = this.modalService.open(ModalChangePasswordComponent);
    modalRef.componentInstance.isShowFooter = true;
    modalRef.componentInstance.data = this.user;
  }

  onClickCancelar() {
    this.location.back();
  }
}
